export default __webpack_public_path__ + "343f8ff3a55657f4e903a704e5641e7d.png";